import home from './bidders/home';
import tenders from './bidders/tenders';

export default [
    ...home,
    ...tenders
];